import { red } from '@material-ui/core/colors';

export default (theme) => ({
  root: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2)
  },
  avatar: {
    width: 100,
    height: 100,
    transition: 'opacity 200ms cubic-bezier(0, 1, 1, 1)',
    '&:hover': {
      opacity: 0.7,
      cursor: 'pointer'
    }
  },
  avatarWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.only('xs')]: {
      paddingBottom: 0
    }
  },
  cancel: {
    backgroundColor: theme.palette.error.main,
    color: 'white',
    [theme.breakpoints.up('xs')]: {
      marginRight: theme.spacing(1)
    },
    '&:hover': {
      backgroundColor: red[300]
    }
  }
});
